module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-highlights-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Sorotan & Putar Ulang")]), _vm._v(" "), _c('div', {
    staticClass: "highlights-carousel"
  }, [(_vm.data.highlight_url) ? _c('iframe', {
    staticClass: "carousel-item",
    attrs: {
      "src": _vm.data.highlight_url,
      "frameborder": "0",
      "fs": "0",
      "modestbranding": "1",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;fs;modestbranding",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.playback_url) ? _c('div', {
    staticClass: "playback-carousel-item carousel-item",
    on: {
      "click": function($event) {
        _vm.handlePlayVideo(_vm.data.playback_url)
      }
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af2c084a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppMatchHighlights.vue
// module id = 670
// module chunks = 1